// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { InstrumentConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/Instrument';

export const useSetProviderAppRewardBeneficiaries = () => {
  const { submit, status } = useExerciseSubmission(
    InstrumentConfiguration.InstrumentConfiguration_SetProviderAppRewardBeneficiaries,
    'Successfully modified provider app reward beneficiaries',
    'Failed to modify app provider reward beneficiaries',
  );
  return { submit, status };
};
